/** Retry read queries only for transient failures, with bounded jitter. */
export function retryReadQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false
  const status = (error as { statusCode?: number } | null)?.statusCode
  return status === undefined || [408, 429, 500, 502, 503, 504].includes(status)
}

export function readRetryDelay(attempt: number, error: unknown): number {
  const retryAfter = (error as { retryAfterMs?: number } | null)?.retryAfterMs
  const backoff = Math.min(30_000, 1000 * 2 ** Math.min(attempt, 5))
  return Math.min(
    2_147_483_647,
    Math.max(
      backoff * (0.8 + Math.random() * 0.4),
      typeof retryAfter === 'number' && Number.isFinite(retryAfter)
        ? Math.max(0, retryAfter) + Math.random() * 1000
        : 0,
    ),
  )
}
